import { getRoleFromLocalStorage } from '@/utils/helper';
import { ReactNode } from 'react';
import NavigateDefault from './DefaultNaivgate';

interface ExcludeRouteProps {
  role: string[];
  children: ReactNode;
}

const ExcludeRoute = ({ role, children }: ExcludeRouteProps) => {
  const userRole = getRoleFromLocalStorage();
  const denyAccess = role.includes(userRole?.toUpperCase() as string);
  return denyAccess ? <NavigateDefault /> : children;
};

export default ExcludeRoute;
